'use client';

import React, { ReactNode,  useEffect } from 'react';
import { useSession } from 'next-auth/react';
import { redirect } from 'next/navigation';

interface IPageWrapperProps {
  children: ReactNode;
}

const PageWrapper = ({children}: IPageWrapperProps) => {

  const session = useSession();

  useEffect(() => {
    if (!session) {
      redirect('/login');
    }
  }, [session]);
  
  return (
    <>
      {children}
    </>
  )
}

export default PageWrapper;